import styled from "styled-components";
import { getHexOpacity } from "../../../../../../../utils/pipes";

export const PdfGenerator = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  .modal-background {
    background-color: ${`#090949${getHexOpacity(0.50)}`};
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 100;
  }
  .modal-container {
    max-height: 90%;
    z-index: 200;
    background-color: var(--white);
    width: 100%;
    height: 95%;
    margin-top: auto;
    box-sizing: border-box;
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    &--reaction {
      padding: 40px;
      display: flex;
    }
    .header {
      padding: 20px 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #E0E6ED;
      &__text {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
      }
      &__title {
        font-family: Nunito Sans;
        font-size: 30px;
        color: #3E3E5B;
        display: flex;
        align-items: center;
      }
      &__subtitle {
        color: #3E3E5B;
        font-family: "Nunito Sans";
        font-size: 18px;
      }
      &__close {
        width: 28px;
        height: 28px;
        background-color: #36369B;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        cursor: pointer;
        color: #fff;
      }
    } 
    .pdf-container {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .footer {
      padding: 20px 40px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
`;

export default PdfGenerator;
